<h6 class="text-body-tertiary bg-light text-center py-3 px-3">Created by <a
		href="https://www.clearbluedesign.com?ref=rpm" target="_blank">Clear Blue Design</a> for MLB
</h6>